import type { UserIdentity } from './types';

type Listener = () => void;

/**
 * Normalized reactive UI read model.
 *
 * Repository rows are never read directly by components. Publication replaces
 * the map once per committed batch, so a list cannot observe a half-applied IM
 * reconnect page.
 */
export class IdentityStore {
  private identities = new Map<number, UserIdentity>();
  private listeners = new Set<Listener>();

  get(userId: number): UserIdentity | undefined {
    return this.identities.get(userId);
  }

  snapshot(): ReadonlyMap<number, UserIdentity> {
    return this.identities;
  }

  publish(rows: UserIdentity[]): void {
    if (rows.length === 0) return;
    const next = new Map(this.identities);
    for (const row of rows) next.set(row.userId, row);
    this.identities = next;
    for (const listener of this.listeners) listener();
  }

  clear(): void {
    if (this.identities.size === 0) return;
    this.identities = new Map();
    for (const listener of this.listeners) listener();
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}
